import React from 'react';
import { Select } from 'antd';

import {
  getSelectedFilterValues,
  getStateFilterOptionLabel,
} from 'utils/filterUtils';
import { TimesheetStatusEnum } from 'api/backofficeApiClient';
import { TimesheetStatusReportFilters } from 'features/home/UserHomePage/TimesheetStatusReportDetailsPage/TimesheetStatusReportFilter/TimesheetStatusReportFilter';
import { TimesheetStatusReportFilterTypes } from '../enums';

type Props = {
  filters: TimesheetStatusReportFilters;
  onChange: (data: TimesheetStatusReportFilters) => void;
};

const stateFilterOptions = [
  TimesheetStatusEnum.All,
  TimesheetStatusEnum.Open,
  TimesheetStatusEnum.Submitted,
  TimesheetStatusEnum.Approved,
];

export default function ApprovalStateFilter(props: Props) {
  const { filters, onChange } = props;

  const handleFilterChange = (type: TimesheetStatusReportFilterTypes) => (
    states: number[],
  ) => {
    const selectedFilterValues = getSelectedFilterValues(
      states,
      TimesheetStatusEnum.All,
    );

    onChange({ ...filters, [type]: selectedFilterValues });
  };

  return (
    <Select
      className="full-width"
      value={filters[TimesheetStatusReportFilterTypes.ApprovalState]}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select an approval state"
      onChange={handleFilterChange(
        TimesheetStatusReportFilterTypes.ApprovalState,
      )}
      showSearch
      data-id="approvalStateFilterField"
    >
      {stateFilterOptions.map((state) => (
        <Select.Option key={`select-state-${state}`} value={state}>
          {getStateFilterOptionLabel(state)}
        </Select.Option>
      ))}
    </Select>
  );
}
